<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>晚自习填报</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>学年：</p>
                    <a-date-picker
                        class="input"
                        mode="year"
                        format='YYYY'
                        v-model="year" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        @panelChange="panelChangeOne">
                        <a-input  v-model="info.schoolYear" />
                    </a-date-picker>
                </div>
                <div class="input-box">
                    <p>学期：</p>
                    <a-select class="input" allowClear v-model="info.semester" >
                        <!-- For years before 2025, keep all options -->
                        <template v-if="year < '2025'">
                            <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                        </template>
                        <!-- For 2025 and later, only show two semesters -->
                        <template v-else>
                            <a-select-option :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                        </template>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>指导老师：</p>
                    <a-select
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.teacherId"
                        @change="teacherSelect"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>系别：</p>
                    <a-select class="input" allowClear v-model="info.orgCode" >
                        <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <!-- <div class="input-box-center">
                    <p>晚自习辅导时间：</p>
                    <a-select default-value="星期一" class="input" allowClear v-model="info.dayOfWeek" >
                        <a-select-option value="星期一">星期一</a-select-option>
                        <a-select-option value="星期二">星期二</a-select-option>
                        <a-select-option value="星期三">星期三</a-select-option>
                        <a-select-option value="星期四">星期四</a-select-option>
                        <a-select-option value="星期五">星期五</a-select-option>
                        <a-select-option value="星期六">星期六</a-select-option>
                        <a-select-option value="星期日">星期日</a-select-option>
                    </a-select>
                    <span style="width:2rem"></span>
                    <a-select default-value="9-10" class="input" allowClear v-model="info.class" >
                        <a-select-option value="9-10">9-10节</a-select-option>
                        <a-select-option value="10-11">10-11节</a-select-option>
                        <a-select-option value="11-12">11-12节</a-select-option>
                    </a-select>
                    <span style="width:2rem"></span>
                    第
                    <a-input-number defaultValue="1" style="margin:0rem 0.5rem 0rem 0.5rem" id="inputNumber1" v-model="info.startWeek" :min="1" :max="10"/>
                    周至第
                    <a-input-number defaultValue="1" style="margin:0rem 0.5rem 0rem 0.5rem" id="inputNumber2" v-model="info.endWeek" :min="1" :max="10"/>
                    周
                </div> -->
                <div class="input-box">
                    <p>辅导教室：</p>
                    <a-input class="input" v-model="info.coachingRoom"/>
                </div>
                <div class="input-box">
                    <p>校区：</p>
                    <!-- <a-input class="input" v-model="info.campus"/> -->
                    <a-select class="input" allowClear v-model="info.campus">
                        <a-select-option value="嘉定校区">嘉定</a-select-option>
                        <a-select-option value="宝山校区">宝山</a-select-option>
                        <a-select-option value="延长校区">延长</a-select-option>
                    </a-select>
                </div>
                
                <div class="input-box-center">
                    <p>晚自习辅导时间：</p>
                    <div class="input">
                        <a-button class="editable-add-btn" @click="handleAdd"  :disabled="type!='add' && type!='edit'">
                        新增
                        </a-button>
                        <a-table bordered :data-source="dataSource" :columns="columns" :pagination="{hideOnSinglePage:true}">
                            <template slot="dayOfWeek" slot-scope="text, record">
                                <a-select style="width:100%" allowClear v-model="record.dayOfWeek" @change="onCellChange( record.sortId,'dayOfWeek', $event)">
                                <a-select-option value="星期一">星期一</a-select-option>
                                <a-select-option value="星期二">星期二</a-select-option>
                                <a-select-option value="星期三">星期三</a-select-option>
                                <a-select-option value="星期四">星期四</a-select-option>
                                <a-select-option value="星期五">星期五</a-select-option>
                            </a-select>
                            </template>
                            <template slot="class" slot-scope="text, record">
                                <a-select  style="width:100%" allowClear v-model="record.class" @change="onCellChange( record.sortId,'class', $event)">
                                    <a-select-option value="9-10">9-10节</a-select-option>
                                    <a-select-option value="10-11">10-11节</a-select-option>
                                    <a-select-option value="11-12">11-12节</a-select-option>
                                </a-select>
                            </template>
                            <template slot="week" slot-scope="text, record">
                                第
                                <a-input-number  style="margin:0rem 0.5rem 0rem 0.5rem" id="inputNumber1" v-model="record.startWeek"  :min="1" :max="18" @change="onCellChange( record.sortId,'startWeek', $event)"/>
                                周至第
                                <a-input-number  style="margin:0rem 0.5rem 0rem 0.5rem" id="inputNumber2" v-model="record.endWeek" :min="1" :max="18" @change="onCellChange( record.sortId,'endWeek', $event)"/>
                                周
                            </template>
                            <!-- <template slot="date2" slot-scope="text, record">
                                <a-date-picker :value='text' placeholder="请选择日期" @change="onCellChange(record.sortId, 'date2', $event)" />
                            </template>
                            <template slot="lessonNum2" slot-scope="text, record">
                                <a-input :disabled="type!='add' && type!='edit'"  style="text-align:center" placeholder="0" addon-before="第" addon-after="节" :value="text" @change="e => onCellChange( record.sortId,'lessonNum2', e.target.value)"/>
                            </template>
                            <template slot="classRoom2" slot-scope="text, record">
                                <a-input :disabled="type!='add' && type!='edit'"  style="text-align:center" placeholder="0"  addon-after="教室" :value="text" @change="e => onCellChange( record.sortId,'classRoom2', e.target.value)"/>
                            </template> -->
                            <template slot="operation" slot-scope="text, record">
                                <a-popconfirm
                                v-if="dataSource.length"
                                title="确认删除?"
                                @confirm="() => onDelete(record.sortId)"
                                >
                                <a href="javascript:;" :disabled="type!='add' && type!='edit'">删除</a>
                                </a-popconfirm>
                            </template>
                        </a-table>
                    </div>
                </div>
                <div class="input-box-center">
                    <p>备注：</p>
                    <a-input class="input" v-model="info.remark"/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-show="type=='add' || type == 'edit'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info } from '@/baseAPI/undergraduate/culture/nightCoaching'
    import { getDicts } from '@/baseAPI/dictionary'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'
    export default {
        name: '',
        data () {
            return {
                coachingRooms:[],
                year:'',
                yearShowOne:false,
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                type:'',
                info:{
                    schoolYear: "",
                    semester: "",
                    orgCode: "",
                    orgName: "",
                    teacherName: "",
                    teacherId: "",
                    coachingTime: "",
                    coachingRoom: "",
                    campus: "宝山",
                    remark:"",
                },
                xbArr:[],
                jsArr:[],
                count: 0,
                dataSource: [
                    {
                        sortId: '0',
                        dayOfWeek:'',
                        class:'',
                        week:'',
                        startWeek:null,
                        endWeek:null
                    }
                ],
                columns:[
                    {
                        title: '星期',
                        dataIndex: 'dayOfWeek',
                        width: '20%',
                        align:'center',
                        scopedSlots: { customRender: 'dayOfWeek' }
                    },
                    {
                        title: '节',
                        dataIndex: 'class',
                        width: '20%',
                        align:'center',
                        scopedSlots: { customRender: 'class' }
                    },
                    {
                        title: '周',
                        align:'center',
                        dataIndex: 'week',
                        width: '40%',
                        scopedSlots: { customRender: 'week' }
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width: '10%',
                        align:'center',
                        scopedSlots: { customRender: 'operation' },
                    },
                ],
            }
        },
        mounted () {
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.info.semester=getSemester()
            this.type=this.$route.query.type;
            this.info.orgCode=this.$store.state.user.orgCode
            this.info.orgName=this.$store.state.user.orgName
            this.info.teacherId=this.$store.state.user.userId
            this.info.teacherName=this.$store.state.user.name
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })

            getDicts({dataCode:'WZXFD_FDJS',status:true}).then(res=>{
                this.coachingRooms=res.data.dicts;
            })

            getTeacher().then(res=>{
                this.jsArr=res.data;
                this.teacherSelect()
            })

            if(this.type!='add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data;
                        this.dataSource=[]
                        res.data.coachingTime.split(';').forEach((item)=>{
                            if(item.indexOf("undefined") < 0){
                                this.dataSource.push({'sortId':this.count,'dayOfWeek':item.split('_')[0],'class':item.split('_')[1].split('[')[0],'startWeek':item.split('-')[1].split('[')[1],'endWeek':item.split('-')[2].split(']')[0]})
                                this.count = this.count + 1;
                            }
                        })
                        // this.info.dayOfWeek=res.data.coachingTime.split('_')[0]
                        // this.info.class=res.data.coachingTime.split('_')[1].split('[')[0]
                        // this.info.startWeek=res.data.coachingTime.split('_')[1].split('[')[1]
                        // this.info.endWeek=res.data.coachingTime.split('-')[2].split(']')[0]
                    })
                },500)
            }
        },
        methods:{
            onCellChange(key, dataIndex, value) {
                const dataSource = [...this.dataSource];
                const target = dataSource.find(item => item.sortId === key);
                if (target) {
                    target[dataIndex] = value;
                    this.dataSource = dataSource;
                }
            },
            onDelete(key) {
                const dataSource = [...this.dataSource];
                this.dataSource = dataSource.filter(item => item.sortId !== key);
                console.log(this.dataSource)
            },
            handleAdd() {
                const { dataSource } = this;
                this.count = this.count + 1;
                const newData = {
                    sortId : this.count
                };
                this.dataSource = [...dataSource, newData];
                console.log(this.dataSource)
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.teacherId){
                        this.info.teacherId=this.jsArr[i].teacherId
                        this.info.teacherName=this.jsArr[i].teacherName
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                    }
                }
                for(let i=0;i<this.coachingRooms.length;i++){
                    if(this.coachingRooms[i].dataCode==this.info.teacherId){
                        this.info.coachingRoom = this.coachingRooms[i].dataDesc
                    }
                }

            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.info.semester='';
                this.yearShowOne = false;
            },
            onChange(e){
                this.info.tysj = e.target.value
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                if(this.dataSource.length > 0){
                    this.dataSource.forEach((item,index)=>{
                        if(item.dayOfWeek == "" || typeof(item.dayOfWeek) == 'undefined' || item.dayOfWeek == null
                            || item.class == "" || typeof(item.class) == 'undefined' || item.class == null
                            || item.startWeek == "" || typeof(item.startWeek) == 'undefined' || item.startWeek == null
                            || item.endWeek == "" || typeof(item.endWeek) == 'undefined' || item.endWeek == null
                        ){
                            isSub = false;
                        }
                        if(index == 0){
                            this.info.coachingTime = item.dayOfWeek+"_"+item.class+"_["+item.startWeek+"-"+item.endWeek+"]"
                        }else{
                            this.info.coachingTime += ';' +item.dayOfWeek+"_"+item.class+"_["+item.startWeek+"-"+item.endWeek+"]"
                        }
                        
                    })
                }else{
                    isSub = false;
                }
                if(isSub){
                    
                    console.log(this.info.coachingTime)
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增晚自习辅导成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改晚自习辅导成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整晚自习辅导时间！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }

    .info-main .table{
        margin-left: 10rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box-center p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box-center .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
